import React, {Component} from 'react';
import config from '../../config/config.js';
import axios from 'axios';

class SSPGotFoodStamp extends Component {
    constructor(props) {
        super(props);

        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(e) {
        e.preventDefault();
        axios(config.server.endpoint + 'backend/shift/setShiftSupporterProjectFoodStamp/' + this.props.id, {
            method: 'put'
        }).then((response) => {
            if (response.status === 200) {
                if (response.data.success === true) {
                    this.props.handleSaveSuccess();
                }
            }
        });
    }

    render() {
        return (
            <button className={"SSPGotFoodStamp btn btn-" + (this.props.checked ? 'primary' : 'default')} onClick={this.handleClick}>
                <i className="fa fa-cutlery"/>
            </button>
        )
    }
}
export default SSPGotFoodStamp;